<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            @if (titleIcon) {
                <mat-icon>{{ titleIcon }}</mat-icon>
            }
            <div>{{ title }}</div>
        </div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'info-dialog'">
        <p [innerHTML]="text"></p>
    </div>

    <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
        <button
            (click)="dialogRef.close()"
            class="btn btn-lg orange info-text-dialog-button"
            [attr.data-testid]="'info-dialog-button-close'"
            mat-button
            type="button">
            {{ buttonText }}
        </button>
    </div>
</mat-dialog-content>
